/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Kind_Bi_DashboardInputs */



/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Artifact_Kind_Bi_DashboardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_kind_bi_dashboard = /** @type {((inputs?: Artifact_Kind_Bi_DashboardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Kind_Bi_DashboardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dashboard")
	return /** @type {LocalizedString} */ ("Dashboard")
});